define('helper-component-setStructure',['exports', './component--get-content.es', './component--parse-prop.es'], function (exports, _componentGetContent, _componentParseProp) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _componentGetContent2 = _interopRequireDefault(_componentGetContent);

    var _componentParseProp2 = _interopRequireDefault(_componentParseProp);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var parse = function parse(content) {

        if (!content || content.constructor !== Object) {
            return {};
        }

        Object.keys(content).map(function (str) {
            var prop = content[str];

            if (!Array.isArray(prop) || !prop.length) {
                return prop;
            }

            var obj = prop[0];

            if (obj.constructor !== Object || !Object.keys(obj).length) {
                return prop;
            }

            if (!obj.hasOwnProperty('kind') || !obj.kind || !obj.hasOwnProperty('content') || !obj.content) {
                return prop;
            }

            content[str] = (0, _componentParseProp2.default)(content, str, obj.kind);
        });

        return content;
    };

    exports.default = function (arr) {

        if (!arr || !Array.isArray(arr)) {
            return {};
        }

        return arr.reduce(function (res, o) {
            if (!o.kind || typeof o.kind !== 'string') {
                return res;
            }

            var kind = o.kind.toLowerCase();

            switch (kind) {
                case 'svgwithtext':
                case 'secondcolumncontent':

                    res[kind] = res[kind] || [];

                    res[kind].push(parse((0, _componentGetContent2.default)([o], o.kind)));

                    break;
                default:
                    res[kind] = parse((0, _componentGetContent2.default)([o], o.kind));
            }

            return res;
        }, {});
    };
});
